// Imports nommés, sans exposer tout l'espace de noms : webpack peut alors écarter Session
// Replay, que les pages publiques n'utilisent pas (#16078)
import { onLoad, init, browserTracingIntegration } from "@sentry/browser";

onLoad(function() {
  init({
    release: "oqoro@" + process.env.RENDER_GIT_COMMIT,
    dsn: "https://b768400c615d44fe8a10e9d4572b0d5f@o386364.ingest.us.sentry.io/4504434083627008",
    environment: 'production',
    integrations: [
      browserTracingIntegration(),
    ],
    tracePropagationTargets: ["oqoro.com", "regie.oqoro.com", "app.oqoro.com", "www.oqoro.com"],
  });
});
